<div class="container-fluid skin-header">
  <div class="row align-items-center">
    <header class="header">
      <div class="logo" (click)="setActiveMenuName('Home')">
        <img alt="GateLockVan Logo" src="../../../assets/img/LogoTop.png"/>
      </div>
      <div class="info">
        <div class="company-name">
          <div *ngIf="SocioSelezionato !==''" class="company-info">{{ 'Main.Company' | translate }}: <b>{{ SocioSelezionato }}</b></div>
        </div>
        <div class="user-name">
          <div *ngIf="NomeUtente !==''" class="user-info">{{ 'Main.User' | translate }}: <b>{{ NomeUtente }}</b></div>
        </div>
      </div>
    </header>
  </div>
</div>
